export const GET_RECENTLY_DATA = "GET_RECENTLY_DATA";
export const GET_RECENTLY_REQUEST = "GET_RECENTLY_REQUEST";
export const GET_RECENTLY_FAILURE = "GET_RECENTLY_FAILURE";

export const HOTEL_SUCCESS = "HOTEL_SUCCESS";
export const HOTEL_REQUEST = "HOTEL_REQUEST";
export const HOTEL_FAILURE = "HOTEL_FAILURE";



